// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

.server-error {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.server-error__center {
  margin: auto;
  margin-top: 10%;
  width: 50%;
  text-align: center;
}

.server-error__title {
  margin: 0 0 1em;
  font-weight: normal;
}

.server-error__details {
  margin-top: 1.5rem;
  text-align: left;
}
.server-error__details h2 {
  margin: 0 0 0.5rem;
  font-size: inherit;
  font-weight: normal;
}
.server-error__details ul {
  margin: 0;
  padding-left: 1.25rem;
}
.server-error__details li + li {
  margin-top: 0.25rem;
}

.server-error__action {
  display: inline-block;
  margin-top: 2rem;
  color: #0066b2;
  text-decoration: underline;
}

@media (max-width: 600px) {
  .server-error__center {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/server-error-page/server-error-page.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;EACA,YAAA;AADD;;AAIA;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AADD;;AAKA;EACC,YAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAFD;;AAMA;EACC,eAAA;EACA,mBAAA;AAHD;;AAMA;EACC,kBAAA;EACA,gBAAA;AAHD;AAKC;EACC,kBAAA;EACA,kBAAA;EACA,mBAAA;AAHF;AAMC;EACC,SAAA;EACA,qBAAA;AAJF;AAOC;EACC,mBAAA;AALF;;AASA;EACC,qBAAA;EACA,gBAAA;EACA,cCnDa;EDoDb,0BAAA;AAND;;AASA;EACC;IACC,WAAA;EANA;AACF","sourcesContent":["@use '../../../styles/colors.scss' as colors;\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.server-error {\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n}\n\n// Mirrors .center-not-found from the page-not-found component.\n.server-error__center {\n\tmargin: auto;\n\tmargin-top: 10%;\n\twidth: 50%;\n\ttext-align: center;\n}\n\n// GothamBold is registered at normal weight; prevent synthetic bold.\n.server-error__title {\n\tmargin: 0 0 1em;\n\tfont-weight: normal;\n}\n\n.server-error__details {\n\tmargin-top: 1.5rem;\n\ttext-align: left;\n\n\th2 {\n\t\tmargin: 0 0 0.5rem;\n\t\tfont-size: inherit;\n\t\tfont-weight: normal;\n\t}\n\n\tul {\n\t\tmargin: 0;\n\t\tpadding-left: 1.25rem;\n\t}\n\n\tli + li {\n\t\tmargin-top: 0.25rem;\n\t}\n}\n\n.server-error__action {\n\tdisplay: inline-block;\n\tmargin-top: 2rem;\n\tcolor: colors.$medium-blue;\n\ttext-decoration: underline;\n}\n\n@media (max-width: 600px) {\n\t.server-error__center {\n\t\twidth: 100%;\n\t}\n}","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
